import React from "react";
import { Stack } from "@mui/material";
import { connect } from "react-redux";

import { DialogButton, HubButton, HubButtonGroup } from "../../components";
import { getVendorStatus, setIsShippingVendor } from "../../redux/shipping";

import { useShipmentOrdersContext } from "./ShipmentOrdersContextProvider";
import ShipmentOrdersFilter from "./ShipmentOrdersFilter";

const buttonProps = {
  size: "xsmall",
  variant: "contained",
  iconProps: { size: 10 },
  sx: { textWrap: "nowrap" },
};
const ReturnTypes = [
  { id: 0, label: "To Customer" },
  { id: 1, label: "To Vendor" },
];

const ShipmentOrdersBar = ({ isVendor, _setIsShippingVendor = () => {} }) => {
  const {
    count,
    onClear = () => {},
    onShip = () => {},
    returnType = isVendor,
    setReturnHelper = () => {},
  } = useShipmentOrdersContext();

  const setSelected = (newValue) => {
    _setIsShippingVendor(!!newValue);
    setReturnHelper(newValue);
  };

  return (
    <Stack
      direction={{ lg: "row", md: "column-reverse" }}
      justifyContent={{ lg: "space-between", md: "center" }}
      alignItems={{ lg: "center", md: "end" }}
      gap="15px"
    >
      <ShipmentOrdersFilter />
      <Stack direction="row" gap="5px" alignItems="center">
        <HubButtonGroup
          buttons={ReturnTypes}
          selected={Number(!!returnType)}
          setSelected={setSelected}
        />
        {!!count && (
          <>
            <HubButton
              label={`Clear ${count} Selected`}
              icon="X"
              color="grey"
              onClick={onClear}
              {...buttonProps}
            />
            <HubButton
              label="Mark as Shipped"
              onClick={onShip}
              disabled={!count}
              {...buttonProps}
            />
          </>
        )}
        <DialogButton
          name="edit-shipping-details"
          label="Create Shipment"
          variant="contained"
          size="xsmall"
          color="neutral"
        />
      </Stack>
    </Stack>
  );
};

const mapStateToProps = (state) => ({
  isReturning: getVendorStatus(state),
});
const mapDispatchToProps = {
  _setIsShippingVendor: setIsShippingVendor,
};
export default connect(mapStateToProps, mapDispatchToProps)(ShipmentOrdersBar);
